<template>
    <div class="mobile-page">
        <div class="box"
             :style="{
                borderBottomWidth: configData.heightConfig.val + 'px',
                borderBottomColor: configData.lineColor.color[0].item,
                borderBottomStyle: configData.lineStyle.list[configData.lineStyle.type].style,
                marginLeft: configData.lrEdge.val +'px',
                marginRight:configData.lrEdge.val +'px',
                marginTop: configData.mbConfig.val +'px',
            }"></div>
    </div>
</template>

<script>
    export default {
        name: "guide",
        sort: 200,
        cname: '辅助线',
        type: 2, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconfuzhuxian1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "guide",
                    cname: '辅助线',
                    tabs: [
                        {
                            title: '样式设置'
                        }
                    ],
                    styles: {
                        lineColor: {
                            title: '线条颜色',
                            tab: 0,
                            name: 'colors',
                            default: [{
                                item: '#f5f5f5'
                            }],
                            color: [
                                {
                                    item: '#f5f5f5'
                                }
                            ]
                        },
                        lineStyle: {
                            title: '线条样式',
                            tab: 0,
                            name: 'radio',
                            type: 0,
                            list: [
                                {
                                    val: '虚线',
                                    style: 'dashed',
                                    icon:''
                                },
                                {
                                    val: '实线',
                                    style: 'solid'
                                },
                                {
                                    val: '点状线',
                                    style: 'dotted'
                                }
                            ]
                        },
                        heightConfig:{
                            title: '组件高度',
                            tab: 0,
                            name: 'slider',
                            val: 1,
                            min: 1
                        },
                        lrEdge:{
                            title: '左右边距',
                            tab: 0,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                        mbConfig: {
                            title: '页面间距',
                            tab: 0,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
